import { lazy } from 'react';

export { default as Landing } from './Landing';
export { default as HomeGateway } from './HomeGateway';
export { default as EnterpriseHome } from './EnterpriseHome';
export { default as BusinessProfileGateway } from './BusinessProfileGateway';
export { default as Education } from './Education';
export { OrphanAccountOptions } from './OrphanAccountOptions';
export const Login = lazy(() => import(/* webpackChunkName: 'login' */ './Login'));
export const Logout = lazy(() => import(/* webpackChunkName: 'login' */ './Logout'));
export const Callback = lazy(() => import(/* webpackChunkName: 'login' */ './Callback'));
export const Download = lazy(() => import(/* webpackChunkName: 'pages.download' */ './Download'));
export const Help = lazy(() => import(/* webpackChunkName: 'pages.help' */ './Help'));
export const AccountNotFound = lazy(() => import(/* webpackChunkName: 'pages.AccountNotFound' */ './AccountNotFound'));
export const AccountNotFoundMobile = lazy(
  () => import(/* webpackChunkName: 'pages.AccountNotFoundMobile' */ './AccountNotFoundMobile'),
);
export const UserBlocked = lazy(() => import(/* webpackChunkName: 'pages.UserBlocked' */ './UserBlocked'));
export const LoginError = lazy(() => import(/* webpackChunkName: 'pages.LoginError' */ './LoginError'));
export const AccountSettings = lazy(() => import(/* webpackChunkName: 'pages.AccountSettings' */ './AccountSettings'));
export const BillingHistory = lazy(() => import(/* webpackChunkName: 'pages.BillingHistory' */ './BillingHistory'));
export const OrderHistory = lazy(() => import(/* webpackChunkName: 'pages.OrderHistory' */ './OrderHistory'));
export const OrderView = lazy(() => import(/* webpackChunkName: 'pages.OrderView' */ './OrderView'));
export const ProductLanding = lazy(() => import(/* webpackChunkName: 'pages.ProductLanding' */ './ProductLanding'));
export const Products = lazy(() => import(/* webpackChunkName: 'pages.Products' */ './Products'));
export const EducationGettingStarted = lazy(
  () => import(/* webpackChunkName: 'pages.education' */ './Education/GettingStarted'),
);
export const EducationRunningAndGrowing = lazy(
  () => import(/* webpackChunkName: 'pages.education' */ './Education/RunningAndGrowing'),
);
export const BusinessOverview = lazy(
  () => import(/* webpackChunkName: 'pages.BusinessOverview' */ './BusinessOverview'),
);
export const PaymentReturn = lazy(() => import(/* webpackChunkName: 'pages.PaymentReturn' */ './PaymentReturn'));
export const SubscriptionCancel = lazy(
  () => import(/* webpackChunkName: 'pages.SubscriptionCancel' */ './SubscriptionCancel'),
);
export const SubscriptionRestart = lazy(
  () => import(/* webpackChunkName: 'pages.SubscriptionRestart' */ './SubscriptionRestart'),
);
export const InvoicePayments = lazy(() => import(/* webpackChunkName: 'pages.InvoicePayments' */ './InvoicePayments'));
export const KlarnaPaymentCheckout = lazy(
  () => import(/* webpackChunkName: 'pages.KlarnaPaymentCheckout' */ './KlarnaPaymentCheckout'),
);
export const Subscriptions = lazy(() => import(/* webpackChunkName: 'pages.Subscriptions' */ './Subscriptions'));
